import React, {useState,useEffect} from 'react';
import {Paper, Typography, Box, Divider, IconButton, useTheme, LinearProgress } from '@mui/material';
import style from '../../css/Activity.module.css';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { useSelector } from 'react-redux';
import { data } from '../../storeredux';
import { RefreshRounded } from '@mui/icons-material';
import { AchievementContainer } from '../others-component/AchievementContainer';

export default function Achievement(props){
  const { setError } = props;
  const theme = useTheme();
  const AutoPlayPlayer = autoPlay(SwipeableViews)
  const [achievement, setAchievement]=useState([]);
  const [nPage, setNPage] = useState(1)
  const [statePage,setStatePage] = useState(0)
  const [index,setIndex] = useState(0);
  const [loading,setLoading] = useState(true)
  const achievementwd = useSelector(data)
  useEffect(() => {
    setLoading(true)
    var length = achievementwd['achievement'].length
    if (length > 0)
      setNPage(Math.ceil(length / 20))
    var st = statePage*20
    var dtraw = achievementwd['achievement'].slice(st,st+20)
    setAchievement(dtraw)
    setLoading(false)
  },[achievementwd])

  const refresh = () => {
    setLoading(true)
    if (statePage+1 < nPage) {
      var st = (statePage+1)*20
      setAchievement(achievementwd['achievement'].slice(st,st+20))
      setStatePage(statePage+1)
    } else {
      setAchievement(achievementwd['achievement'].slice(0,20))
      setStatePage(0)
    }
    setLoading(false)
  }

  const visible = () => (
    <Paper elevation={10} style={{borderRadius:20,backgroundColor:'#ffb380',padding:'15px'}}>
      <Box justifyContent='center' alignItems='center' display='flex' style={{minHeight:'inherit',position:'relative'}}>
        <Typography variant='h5' style={{width:'100%', color:'#ff6600',textAlign:'center'}}>
          <b>No Data</b>
        </Typography>
      </Box>
    </Paper>
  )

  const loadinit = () => (
    <Paper elevation={10} style={{borderRadius:20,backgroundColor:'#595959',padding:'15px'}}>
      <Box justifyContent='center' alignItems='center' display='flex' style={{minHeight:'inherit',position:'relative'}} sx={{flexWrap:'wrap',color:'white'}}>
        <LinearProgress color="inherit" sx={{width:'100%'}}/>
        <Typography variant='h6' color="inherit">Loading</Typography>
      </Box>
    </Paper>
  )

  return(
    <Box id='Achievement' className={style.main}>
      <Box id='tit-oach' style={{marginTop: '50px',width:'100%',marginBottom:'40px'}}>
        <Box sx={{backgroundColor:'#66ff66', top:'10vh', left:'10vw',
          height: '50px', width: {xs:'30vw',md:'10vw'}, position:'relative', zIndex:-1}}/>
        <Box sx={{backgroundColor:'#66ff33', top:'12vh', right:'2vw',
          height: '50px', width: {xs:'30vw',md:'10vw'}, position:'relative', zIndex:-1}}/>
        <Box display='flex'>
          <Typography variant='h3' style={{backgroundColor:'#33cc33'}}>
            <span className={style.titleMain}><b>Our Achievement</b></span>
          </Typography>
        </Box>
        <Divider variant='fullWidth' style={{backgroundColor:'#33cc33',height:'5px'}}/>
      </Box>
      <Box id='ach-cont' className={style.submain}>
        {
          (achievement.length > 0)? 
            <AutoPlayPlayer 
              interval={30000}
              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={index}
              onChangeIndex={(i) => {setIndex(i)}}
              enableMouseEvents>
              {
                achievement.map((a,y) => (
                  <Box key={y} sx={{padding:'10px',display:'flex',alignItems:'center',justifyContent:'center'}}>
                    <AchievementContainer
                      index={y}
                      setError={setError}
                      title={a.title}
                      images={(a.images && a.images.length > 0)? a.images:[]}
                      tanggal={a.tanggal}
                      descMain={a.descMain}
                      clr={y%4}
                    />
                  </Box>
                ))
              }
            </AutoPlayPlayer>:
            <Box justifyContent='center' alignItems='center' display='flex' className={style.cardAct}>
              <Box style={{width:'100%', paddingRight: '15px',paddingLeft:'15px'}}>
                {
                  (loading)?loadinit():visible()
                }
              </Box>
            </Box>
        }
      </Box>
      <Box className={style.submain} sx={{width:'100%',marginTop:'40px'}}>
        <IconButton color='primary' onClick={() => {refresh()}}>
          <RefreshRounded fontSize='large'/>
        </IconButton>
      </Box>
    </Box>
  )
}
